import Vue from "vue";
import VueRouter from "vue-router";
// 引入组件
import home from "../views/home.vue";
import solo from "../views/solo.vue";
import download from "../views/download.vue";
import contact_us from "../views/contact.vue";
import pricing from "../views/pricing.vue";
import error from "../views/error.vue";
import enterprise from "../views/enterprise.vue";
import desktron from "../views/desktron.vue";
import replaceCitrix from "../views/replaceCitrix.vue";
import desktronContact from "../views/desktronContact.vue";
import desktronTrial from "../views/desktronTrial.vue";
import contact_mob from "../views/contact_mob.vue";
import contactLite_mob from "../views/contactLite_mob.vue";
import Trial from "../views/trial.vue";
import design from "../views/solutions/design.vue";
import telework from "../views/solutions/telework.vue";
import localization from "../views/solutions/localization.vue";
import remoteSupport from "../views/solutions/remoteSupport.vue";

import helpcenter from "../views/helpcenter/index.vue";
import videoTutorial from "../views/helpcenter/videoTutorial.vue";
import document from "../views/helpcenter/document.vue";

import soloDetail from "../views/pricingNext/soloCmp.vue";
import priceEnterprise from "../views/pricingNext/ep.vue";
import enterpriseDetail from "../views/pricingNext/epCmp.vue";

import priceDesktron from "../views/pricingNext/dt.vue";

import resourceCenter from "../views/resourceCenter/index.vue";
import news from "../views/resourceCenter/news.vue";
import newsDetail from "../views/resourceCenter/detail.vue";

import join from "../views/join/index.vue";
import joinDetail from "../views/join/detail.vue";

// 要告诉 vue 使用 vueRouter
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/home",
    meta: { title: "ToDesk远程桌面软件-免费安全流畅的远程连接电脑手机" },
  },
  {
    path: "/home",
    component: home,
    meta: { title: "ToDesk远程桌面软件-免费安全流畅的远程连接电脑手机" },
  },
  {
    path: "/solo",
    component: solo,
    meta: { title: "ToDesk远程桌面软件-免费安全流畅的远程连接电脑手机" },
  },
  {
    path: "/download",
    component: download,
    meta: {
      title: "ToDesk远程桌面软件下载-电脑客户端，移动app官网下载-ToDesk官网",
    },
  },
  {
    path: "/contact_us",
    component: contact_us,
    meta: { title: "ToDesk商务合作联系电话-公司地址邮箱-ToDesk官网-" },
  },
  {
    path: "/pricing_individual.html",
    component: pricing,
    meta: { title: "ToDesk远程桌面软件价格，系统购买多少钱-ToDesk官网" },
  },
  {
    path: "/pricing/soloDetail",
    component: soloDetail,
    meta: { title: "ToDesk远程桌面软件价格，系统购买多少钱-ToDesk官网" },
  }, 
  {
    path: "/pricing_enterprise.html",
    component: priceEnterprise,
    meta: { title: "ToDesk远程桌面软件价格，系统购买多少钱-ToDesk官网" },
  },
  {
    path: "/pricing_pc",
    component: priceDesktron,
    meta: { title: "ToDesk远程桌面软件价格，系统购买多少钱-ToDesk官网" },
  },
  {
    path: "/pricing/enterpriseDetail",
    component: enterpriseDetail,
    meta: { title: "ToDesk远程桌面软件价格，系统购买多少钱-ToDesk官网" },
  },
  { path: "/solutions/design", component: design },
  { path: "/solutions/telework", component: telework },
  { path: "/solutions/localization", component: localization },
  { path: "/solutions/remoteSupport", component: remoteSupport },
  { path: "/enterprise", component: enterprise },
  {
    path: "/desktron",
    component: desktron,
    meta: {
      title: "Desktron云桌面，高清、高性能、高效、高可用的安全云桌面",
    },
  },
  {
    path: "/desktron/replaceCitrix",
    component: replaceCitrix,
    meta: {
      title: "Desktron云桌面，高清、高性能、高效、高可用的安全云桌面",
    },
  },
  {
    path: "/desktron/contact",
    component: desktronContact,
    meta: {
      title: "Desktron云桌面，高清、高性能、高效、高可用的安全云桌面",
    },
  },
  {
    path: "/desktron/replaceCitrix/contact",
    component: desktronContact,
    meta: {
      title: "Desktron云桌面，高清、高性能、高效、高可用的安全云桌面",
    },
  },
  {
    path: "/desktron/trial",
    component: desktronTrial,
    meta: {
      title: "Desktron云桌面，高清、高性能、高效、高可用的安全云桌面",
    },
  },
  {
    path: "/desktron/:path",
    component: desktron,
    meta: {
      title: "Desktron云桌面，高清、高性能、高效、高可用的安全云桌面",
    },
    beforeEnter: (to, from, next) => {
      const validPaths = ["application", "solutions", "design"];
      if (validPaths.includes(to.params.path)) {
        next();
      } else {
        next("/desktron");
      }
    },
  },
  { path: "/contact_mobile", component: contact_mob },
  { path: "/contactLite_mobile", component: contactLite_mob },
  { path: "/trial", component: Trial },
  { path: "/helpcenter", component: helpcenter },
  { path: "/helpcenter/videoTutorial", component: videoTutorial },
  { path: "/helpcenter/:type/:id", component: document },
  { path: "/resourceCenter", component: resourceCenter },
  { path: "/news", component: news },
  { path: "/news/:id", component: newsDetail },
  {
    path: "/game",
    name: "gameMb",
    component: () => import("@/views/game/index.vue"),
  },
  {
    path: "/perform",
    name: "performMb",
    component: () => import("@/views/perform/index.vue"),
  },
  { path: "/join", component: join },
  { path: "/join/detail", component: joinDetail },
  { path: "*", component: error, meta: { title: "页面不存在" } },
];

const router = new VueRouter({
  mode: "hash",
  routes,
});

// 导航守卫
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title =
      to.meta.title || "ToDesk远程桌面软件-免费安全流畅的远程连接电脑手机";
  }
  next();
});
router.afterEach((to) => {
  const customPath = to.params ? to.params.path || "" : "";
  if (!["application", "solutions", "design"].includes(customPath)) {
    window.scrollTo(0, 0);
  }
});
export default router;
